import { DefaultizedPieValueType, PieValueType } from "@mui/x-charts/models";
import { PieChart } from "@mui/x-charts/PieChart";
import { MakeOptional } from "@mui/x-date-pickers/internals";

import { PieChartStyle, sizing } from "../styles/style";
import { formatPercentageValue } from "../../../utils";
import colors from "../../../styles/colors/colors";

export interface PropsFromState {
  data: MakeOptional<PieValueType, "id">[];
}

type AllProps = PropsFromState;

const CustomPieChart: React.FC<AllProps> = ({ data }) => {
  const getArcLabel = (params: DefaultizedPieValueType) => {
    if (params.color !== colors.portalColor[30]) return "";
    return formatPercentageValue(
      isNaN(params.value) || params.value === undefined ? "0%" : `${(params.value * 100).toFixed(2)}%`
    );
  };

  return (
    <PieChart
      series={[
        {
          outerRadius: 60,
          data,
          arcLabel: getArcLabel,
        },
      ]}
      tooltip={{ trigger: "none" }}
      sx={PieChartStyle}
      {...sizing}
    />
  );
};

export default CustomPieChart;
